import { Box } from '@material-ui/core';

import { EditAutoPaymentMethodSummaryRow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/components/_shared/EditAutoPaymentMethodSummaryRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export interface EditAutoPaymentMethodSummaryRowData {
  labelTextId: string;
  originalValue: string;
  newValue: string;
  hasChanged: boolean;
  endAdornment?: string | React.ReactNode;
}

interface EditAutoPaymentMethodSummarySectionProps {
  rows: EditAutoPaymentMethodSummaryRowData[];
  titleTextId?: string;
  children?: React.ReactNode;
}

export const EditAutoPaymentMethodSummarySection = ({
  titleTextId,
  rows,
  children,
}: EditAutoPaymentMethodSummarySectionProps) => (
  <Box display="flex" flexDirection="column" gridGap={12}>
    {titleTextId && (
      <Font variant="body2" color="title" style={{ fontWeight: 600 }}>
        <Text tId={titleTextId} />
      </Font>
    )}
    <Box display="flex" flexDirection="column" gridGap={6}>
      {rows.map((row) => (
        <EditAutoPaymentMethodSummaryRow key={row.labelTextId} {...row} />
      ))}
    </Box>
    {children}
  </Box>
);
